import React from "react";
import Features from "../modules/Features.js";

const About = () => {
	return <Features />;
};

export default About;